import { __assign } from "tslib";
import axios from 'axios';
import { MembersNgApi, } from '@wix/ambassador-members-ng-api/http';
import { buildQuery } from '../../utils/urlUtils';
import Url from 'url-parse';
import { MembersRequestBuilder } from '../../model/Member/MembersRequestBuilder';
var SiteMembersServiceUrl = '/_api/members/';
function getMembersAreaApiUrl(origin) {
    // dev.wix-code.com/_api/members-follow-server/v1/followings/ca9e5f23-9273-4a42-8891-d059d9b192e2 400
    var url = new Url(origin);
    return url.origin + "/_api/members-follow-server/v1/";
}
var MembersApi = /** @class */ (function () {
    /**
     * @param {string} token - jwt for site instance
     * (see [more](https://github.com/wix-private/platformization-guidelines/blob/master/guides/instance.md#instance))
     * @param {string} apiUrl
     */
    function MembersApi(token, apiUrl) {
        this.token = token;
        this.axios = axios.create({
            baseURL: apiUrl,
            headers: {
                Authorization: token,
            },
        });
        this.siteMembersClient = MembersNgApi(SiteMembersServiceUrl).Members()({
            Authorization: token,
        });
        var membersAreaBaseURL = getMembersAreaApiUrl(apiUrl);
        this.membersAreaClient = axios.create({
            baseURL: membersAreaBaseURL,
            headers: {
                Authorization: token,
            },
        });
    }
    MembersApi.prototype.getUrl = function (groupId) {
        return "/v1/groups/" + groupId + "/members";
    };
    MembersApi.prototype.listGroupMembers = function (groupId, params) {
        return this.axios.get(this.getUrl(groupId), {
            params: params,
        });
    };
    MembersApi.prototype.listAllMembers = function (groupId, params) {
        return this.axios.get(this.getUrl(groupId) + "/all", {
            params: params,
        });
    };
    MembersApi.prototype.queryAllMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post(this.getUrl(groupId) + "/all", { query: query });
    };
    MembersApi.prototype.maybeChangeQuery = function (query) {
        var req = new MembersRequestBuilder()
            .withQuery(query)
            .replaceFieldNames({ name: 'profile.nickname' })
            .build();
        return req.query;
    };
    MembersApi.prototype.getSiteMembersCount = function () {
        return this.siteMembersClient.queryMembers({
            fieldSet: 'FULL',
        });
    };
    MembersApi.prototype.querySiteMembers = function (queryRequest) {
        return this.siteMembersClient.queryMembers(__assign({ fieldSet: 'FULL' }, queryRequest));
    };
    MembersApi.prototype.queryNonGroupMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post(this.getUrl(groupId) + "/non_group", { query: query });
    };
    MembersApi.prototype.queryGroupMembers = function (_a) {
        var groupId = _a.groupId, query = _a.query;
        return this.axios.post("" + this.getUrl(groupId), { query: query });
    };
    MembersApi.prototype.listPendingMembers = function (groupId, limit, cursorToken) {
        var q = limit || cursorToken ? "?" + buildQuery({ limit: limit, cursorToken: cursorToken }) : '';
        return this.axios.get(this.getUrl(groupId) + "/pending" + q);
    };
    MembersApi.prototype.followMember = function (siteMemberId) {
        return this.membersAreaClient.post("follow/" + siteMemberId);
    };
    MembersApi.prototype.unfollowMember = function (siteMemberId) {
        return this.membersAreaClient.post("unfollow/" + siteMemberId);
    };
    /**
     *
     * @param {string} siteMemberId
     * @return {Promise<AxiosResponse<ListFollowingsResponse>>}
     */
    MembersApi.prototype.getFollowingMembers = function (siteMemberId) {
        // TODO: over 9000 followings?
        return this.membersAreaClient.get("followings/" + siteMemberId);
    };
    MembersApi.prototype.approveGroupMembershipRequests = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/approve", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.rejectGroupMembershipRequests = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/reject", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.joinGroup = function (groupId, membershipQuestionsAnswers) {
        return this.axios.post(this.getUrl(groupId) + "/me", {
            membership_question_answers: membershipQuestionsAnswers,
        });
    };
    MembersApi.prototype.withdrawRequestToJoin = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/request");
    };
    MembersApi.prototype.submitRequestToJoin = function (groupId, membershipQuestionsAnswers) {
        return this.axios.post(this.getUrl(groupId) + "/request", {
            membership_question_answers: membershipQuestionsAnswers,
        });
    };
    MembersApi.prototype.leaveGroup = function (groupId) {
        return this.axios.delete(this.getUrl(groupId) + "/me");
    };
    MembersApi.prototype.getGroupMember = function (groupId, siteMemberId) {
        return this.axios.get(this.getUrl(groupId) + "/member/" + siteMemberId);
    };
    MembersApi.prototype.addToGroup = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/add", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.addAllNonGroupMembersToGroup = function (groupId, excludedSiteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/non_group/add", {
            excludedSiteMemberIds: excludedSiteMemberIds,
        });
    };
    MembersApi.prototype.removeFromGroup = function (groupId, siteMemberIds) {
        return this.axios.post(this.getUrl(groupId) + "/remove", {
            siteMemberIds: siteMemberIds,
        });
    };
    MembersApi.prototype.setMemberRole = function (groupId, siteMemberId, role) {
        return this.axios.post(this.getUrl(groupId) + "/" + siteMemberId + "/role", {
            role: role,
        });
    };
    MembersApi.prototype.getCurrentSiteMember = function () {
        // TODO: is there a SDK method?
        return this.siteMembersClient.getMyMember({
            fieldSet: 'FULL',
        });
    };
    MembersApi.prototype.joinCommunity = function () {
        return this.siteMembersClient.joinCommunity({});
    };
    MembersApi.prototype.countNewMembers = function (groupId, query) {
        return this.axios.post(this.getUrl(groupId) + "/count", { query: query });
    };
    MembersApi.prototype.countNonGroupMembers = function (groupId) {
        return this.axios.get(this.getUrl(groupId) + "/non_group/count");
    };
    MembersApi.prototype.getMembershipQuestions = function (groupId) {
        return this.axios.get("v1/groups/" + groupId + "/membership-questions");
    };
    MembersApi.prototype.saveMembershipQuestions = function (_a) {
        var groupId = _a.groupId, questions = _a.questions;
        return this.axios.post("v1/groups/" + groupId + "/membership-questions", {
            questions: questions,
        });
    };
    MembersApi.prototype.listMembershipQuestionAnswers = function (groupId, siteMemberIds, itemsFilter) {
        var req = {
            itemsFilter: itemsFilter,
            groupId: groupId,
            siteMemberIds: siteMemberIds,
        };
        return this.axios.post("v1/groups/" + groupId + "/membership-answers", req);
    };
    return MembersApi;
}());
export { MembersApi };
//# sourceMappingURL=MembersApi.js.map